import { LoginComponent } from './login/login.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ContainerComponent } from './container/container.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { LotPrintComponent } from './transactions/lot-print/lot-print.component';
import { DiscountPrintComponent } from './orders/discount-print/discount-print-print.component';

const routes: Routes = [
  {
    path: '',
    component: ContainerComponent,
    children: [
      { path: '', component: DashboardComponent },
      {
        path: 'collection',
        loadChildren: () =>
          import('./collections/collections.module').then(
            (m) => m.CollectionsModule
          ),
      },
      {
        path: 'transactions',
        loadChildren: () =>
          import('./transactions/transactions.module').then(
            (m) => m.TransactionsModule
          ),
      },
      {
        path: 'commerces',
        loadChildren: () =>
          import('./commerce/commerce.module').then((m) => m.CommerceModule),
      },
      {
        path: 'admin',
        loadChildren: () =>
          import('./admin/admin.module').then((m) => m.AdminModule),
      },
      {
        path: 'orders',
        loadChildren: () =>
          import('./orders/orders.module').then((m) => m.OrdersModule),
      },
    ],
  },
  { path: 'login', component: LoginComponent },
  { path: 'lot-print', component:  LotPrintComponent},
  { path: 'discount-print', component: DiscountPrintComponent },
  { path: '**', redirectTo: '', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
